export enum BankAccountDetailsAction {
    request = 'request',
    update = 'update',
}
